import { useContext } from 'react';

import { getUnitSymbols, UnitSymbols } from '../../utils/proj4/units';
import { ProjectSpatialReferenceContext } from '../state/project-reference-state';

/**
 * Returns the length, area and volume symbols for the project's coordinate system,
 * meters when rendered outside a project.
 */
export const useUnitSymbols = (): UnitSymbols => {
  // The context has no default value, so it is undefined outside ProjectReferenceProvider.
  const linearUnit = useContext(ProjectSpatialReferenceContext)?.linearUnit ?? 'm';
  return getUnitSymbols(linearUnit);
};
